export default "__VITE_ASSET__CSKDf777__"